import { combineReducers } from 'redux';
import searchResults from './searchResults.reducer';
import MCSInfo from './multiContentSearch.reducer';
import talentInfo from './talent.reducer';
import resultTalent from '../../../NewSearchTalentPage/Redux/reducers/talentResult.reducer';
import talenInfoVcard from './talentFromVcard.reducer';

export default combineReducers({
    searchResults,
    MCSInfo,
    talentInfo,
    resultTalent,
    talenInfoVcard,
})
